<mat-tab-group (selectedTabChange)="onTabChange($event)">
    <mat-tab label="Photos">
        <ng-template matTabContent>
            <div class="uploda_photos" *ngIf="is_myProfile && profileComplete">
                <app-upload-photos></app-upload-photos>
            </div>
            <div *ngIf="!profileComplete">
            <div class="empty">You must create your profile before you can use Upload Photos features</div>
            <a (click)="navigate()" class="click">Click here</a>
            </div>
            <div [class.photos_component]="is_myProfile" *ngIf="profileComplete">
                <app-user-photos [show_title]="false" *ngIf="!album_id"></app-user-photos>
            </div>
            
        </ng-template>
    </mat-tab>
    <mat-tab label="Albums">
        <ng-template matTabContent>
            <section class="albums_container" *ngIf="!album_imgs && profileComplete">
                <div class="profile-section-content">
                    <div class="album-list-inner box-border">
                        <div class="box-pedding profile-user-albums-inner wpee-block-content">
                            <ul class="album-main-wrapper">
                                <ng-container *ngIf="!isLoading">
                                    <li class="album-section-12" *ngFor="let album of albums;">
                                        <div class="album-wrapper">
                                            <figure class="image-holder" (click)="album_in(album)">
                                                <a>
                                                    <span class="image-bg" #eaf5ff
                                                        [style.background]="'url(' + album.last_uploaded_photo_url + ') no-repeat center/cover'"></span>
                                                </a>
                                            </figure>
                                            <div class="album-content-wrap">
                                                <div class="title-wrapper">
                                                    <h6 title="{{album.name}}">
                                                        <a class="album-name">{{album.name}}</a>
                                                    </h6>
                                                </div>
                                                <a *ngIf="is_myProfile" class="wpee-edit-button"
                                                    (click)="editAlbum(album)">
                                                    <fa-icon [icon]="faPencil"></fa-icon>
                                                </a>
                                                <a *ngIf="is_myProfile" class="wpee-delete-button"
                                                    (click)="deleteAlbum(album)">
                                                    <fa-icon [icon]="faDeleteLeft"></fa-icon>
                                                </a>
                                            </div>
                                        </div>
                                    </li>
                                </ng-container>
                                <span class="dsp_span_pointer empty"
                                    *ngIf="albums.length == 0 && is_myProfile && !isLoading">No
                                    Album added</span>
                                <div class="profile-section-content"
                                    *ngIf="albums.length == 0 && !is_myProfile && !isLoading">
                                    <div class="photo-list-inner">
                                        <div class="profile-user-photos-inner wpee-block-content">
                                            <div style="text-align: center; display: grid;"
                                                class="wpee-empty-info wpee-info">
                                                <span style="color: #FF0000;">
                                                    The user has not created any albums.</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div [ngClass]="{'shine':isLoading}">
                                </div>
                            </ul>
                            <a *ngIf="is_myProfile" class="wpee-create-button" (click)="isOpen()">
                                <fa-icon [icon]="faplus"></fa-icon>Add Album
                            </a>
                        </div>
                    </div>
                    <div class="album-popup-main-wrapper popup-main-wrapper" [ngClass]="{'is-open':is_open}">
                        <span class="album-pop-up-bg pop-up-bg" (click)="isClose()"></span>
                        <div class="album-popup-wrapper popup-wrapper">
                            <h6 class="album-popup-title popup-title" *ngIf="!is_update">Add Album</h6>
                            <h6 class="album-popup-title popup-title" *ngIf="is_update">Edit Album</h6>
                            <span class="close_icon" (click)="isClose()"><img [src]="this.apiservices.frontendAssetsUrl+'close.svg'"
                                    alt=""></span>
                            <form class="album-popup-form popup-form" [formGroup]="formGroup">
                                <label for="album_name">Album Name</label>
                                <div class="form-group">
                                    <mat-form-field appearance="outline" class="full-width">
                                        <input matInput type="text" name="album_name" id="album_name"
                                            formControlName="album_Name1" [(ngModel)]="album_Name1"
                                            (keydown.enter)="onEnterPress($event)" />
                                        <mat-error *ngIf="is_valid">Please Enter Album Name</mat-error>
                                    </mat-form-field>
                                </div>
                                <div class="form-group">
                                    <mat-checkbox name="make_private" id="make_private"
                                        formControlName="make_private">Make
                                        Private</mat-checkbox>
                                </div>
                                <div class="form-group">
                                    <button mat-raised-button color="primary" class="save-button" (click)="addAlbum()"
                                        *ngIf="!is_update">
                                        {{showText?'Save':'Please wait...'}}
                                        <mat-spinner *ngIf="!showText" class="custom-spinner"></mat-spinner>
                                    </button>
                                    <button mat-raised-button color="accent" class="save-button update_btn" (click)="updateAlbum()"
                                        *ngIf="is_update">
                                        {{showText?'Update':'Please wait...'}}
                                        <mat-spinner *ngIf="!showText" class="custom-spinner"></mat-spinner>
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div class="album-popup-main-wrapper popup-main-wrapper" [ngClass]="{'is-open':is_delete}">
                        <span class="album-pop-up-bg pop-up-bg" (click)="isClose()"></span>
                        <div class="album-popup-wrapper popup-wrapper">
                            <h6 class="album-popup-title popup-title">Delete Album</h6>
                            <span class="close_icon" (click)="isClose()"><img [src]="this.apiservices.frontendAssetsUrl+'close.svg'"
                                    alt=""></span>
                            <div class="delete_alert">
                                <p>Are You Delete This Album ?</p>
                            </div>
                            <div class="delete_btns">
                                <button class="save-button" (click)="isClose()">No</button>
                                <button class="save-button" (click)="confirmDelete(this.album_id)">
                                    <span *ngIf="showText">Yes</span>
                                    <mat-spinner *ngIf="!showText"></mat-spinner>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div *ngIf="!profileComplete">
                <div  class="empty">You must create your profile before you can use Create Album features</div>
                <a (click)="navigate()" class="click">Click here</a>
            </div >
            <section class="album_imgs" *ngIf="album_imgs && profileComplete">
                <div class="album_img_container" (click)="back_album()">
                    <span><fa-icon [icon]="fa_back"></fa-icon></span>
                    <p><span>Album Name :</span> {{this.album_name}}</p>
                </div>
                <div class="upload_photos_btns">
                    <app-upload-photos [albumId]="album_id" *ngIf="is_myProfile"></app-upload-photos>
                    <app-user-photos [show_title]="false" [albumId]="album_id" *ngIf="album_id"></app-user-photos>
                </div>
            </section>
        </ng-template>

        
    </mat-tab>
</mat-tab-group>